/* Zeratta Size Guide: light, centered native dialog on desktop and mobile. */
(function () {
  if (window.__zrSizeGuideModalReady) return;
  window.__zrSizeGuideModalReady = true;

  function findDialog(opener) {
    var id = opener.getAttribute('aria-controls');
    return id ? document.getElementById(id) : null;
  }

  // Add units to verified centimeter tables imported from supplier HTML.
  // Keep size codes and non-centimeter measurements untouched.
  function labelCentimeterHeaders(dialog) {
    var unitText = dialog.querySelector('.zr-size-guide__unit');
    if (!unitText || !/measurements\s+in\s+cm\b/i.test(unitText.textContent || '')) return;

    dialog.querySelectorAll('.zr-size-guide__measurements table').forEach(function (table) {
      var headerRow = table.querySelector('thead tr') || table.querySelector('tr');
      if (!headerRow) return;
      headerRow.querySelectorAll('th, td').forEach(function (cell) {
        var label = (cell.textContent || '').replace(/\s+/g, ' ').trim();
        if (!label || /\b(cm|inch|inches|mm|kg|lbs?)\b/i.test(label)) return;
        if (/\b(size|weight|age)\b/i.test(label)) return;
        if (!/(bust|chest|length|shoulder|sleeve|waist|hip|width|inseam|hem|cuff|circumference|arm|thigh|height)/i.test(label)) return;
        cell.textContent = label + ' (cm)';
      });
    });
  }

  function openDialog(opener) {
    var dialog = findDialog(opener);
    if (!dialog || dialog.open) return;
    labelCentimeterHeaders(dialog);

    // On mobile the theme's product picker can be clipped or transformed.
    // Place the dialog directly under body so the native top layer is reliable.
    if (dialog.parentNode !== document.body) document.body.appendChild(dialog);

    dialog._zrSizeOpener = opener;
    try {
      if (typeof dialog.showModal === 'function') {
        dialog.showModal();
      } else {
        dialog.setAttribute('open', '');
      }
      opener.setAttribute('aria-expanded', 'true');
    } catch (error) {
      // Avoid a dead button if another theme dialog temporarily blocks showModal.
      if (!dialog.open) dialog.setAttribute('open', '');
      opener.setAttribute('aria-expanded', 'true');
    }
  }

  function closeDialog(dialog) {
    if (!dialog) return;
    if (typeof dialog.close === 'function' && dialog.open) {
      dialog.close();
    } else {
      dialog.removeAttribute('open');
      resetOpener(dialog);
    }
  }

  function resetOpener(dialog) {
    var opener = dialog._zrSizeOpener;
    if (opener && opener.isConnected) opener.setAttribute('aria-expanded', 'false');
  }

  // Capture the click before theme variant-picker/mobile handlers can swallow it.
  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!(target instanceof Element)) return;

    var opener = target.closest('[data-zr-size-open]');
    if (opener) {
      event.preventDefault();
      event.stopPropagation();
      openDialog(opener);
      return;
    }

    var close = target.closest('[data-zr-size-close]');
    if (close) {
      event.preventDefault();
      closeDialog(close.closest('[data-zr-size-dialog]'));
      return;
    }

    var dialog = target.closest('[data-zr-size-dialog]');
    if (dialog && target === dialog) {
      var box = dialog.getBoundingClientRect();
      if (event.clientX < box.left || event.clientX > box.right ||
          event.clientY < box.top || event.clientY > box.bottom) {
        closeDialog(dialog);
      }
    }
  }, true);

  // Native close covers Escape on desktop and the system Back gesture on mobile.
  document.addEventListener('close', function (event) {
    if (event.target.matches && event.target.matches('[data-zr-size-dialog]')) {
      resetOpener(event.target);
    }
  }, true);
})();
